import { Injectable } from '@angular/core';
import { INDRAApiService } from './api.indra.service';
import { INDRAEmergencyData } from '@ibe.models/pax.indra.model.lib';
import { Observable } from 'rxjs';
import { URL_ROOT } from '@ibe.config';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class PassengerPctcService {

	constructor(
		private apiService: INDRAApiService
	) { }

	public saveEmergencyData(data: INDRAEmergencyData, pnr: string, passenger_id: number): Observable<any> {
		const URL = `${URL_ROOT}booking/pnrs/${pnr}/passengers/${passenger_id}/pctc/update`;
		const [firstName, lastName] = this.getNamesArray(data.emName);
		const emergencyRequest = {
			countryCode: data.emCountry,
			emergencyFlag: !data.declined,
			firstName: firstName,
			lastName: lastName,
			telephone: {
				countryCode: data.emPrefix,
				phoneNumber: data.emPhone
			}
		};

		return this.apiService.INDRA_put(URL, emergencyRequest);
	}

	private getNamesArray(name: string): Array<string> {
		if (!_.isEmpty(name)) {
			const names = name.split(' ');
			if (Object.is(1, names.length)) {
				return [names[0], names[0]];
			} else {
				return [names[0], _.tail(names).join(' ')];
			}
		}
		return [null, null];
	}
}
